var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function getPriceValue(record) {
    if (record.currentPrice != null && Number(record.currentPrice) > 0) {
        return Number(record.currentPrice).toFixed(2);
    }
    var arr = record.priceData;
    if (!Array.isArray(arr) || arr.length === 0)
        return "—";
    var lastNonZero = __spreadArray([], arr, true).reverse().find(function (v) { return v != null && Number(v) > 0; });
    var val = lastNonZero !== null && lastNonZero !== void 0 ? lastNonZero : Math.max.apply(Math, arr.filter(function (v) { return Number.isFinite(v); }));
    return Number.isFinite(val) ? Number(val).toFixed(2) : "—";
}
export var createHourlyPriceColumns = function (range) {
    var ROOM_TYPE_NAME_MAX_LEN = 6;
    var renderRoomTypeName = function (label) {
        if (!label)
            return label;
        var s = String(label);
        if (s.length <= ROOM_TYPE_NAME_MAX_LEN)
            return s;
        return "".concat(s.slice(0, ROOM_TYPE_NAME_MAX_LEN), "..");
    };
    var trendTitle = range === "24h" ? "近24小时" : "近7天";
    return [
        {
            title: "房型",
            dataIndex: "label",
            key: "label",
            width: 64,
            cellType: "text",
            align: "right",
            render: function (val) { return renderRoomTypeName(val !== null && val !== void 0 ? val : ""); },
        },
        {
            title: "价格",
            dataIndex: "priceData",
            key: "priceValue",
            width: 56,
            align: "right",
            render: function (_, record) { return getPriceValue(record); },
        },
        {
            title: trendTitle,
            dataIndex: "priceData",
            key: "priceData",
            width: 80,
            cellType: "minichart",
            cellConfig: { chartType: "line", height: 32, chartColor: "#52c41a", smooth: false },
        },
    ];
};
